import {Icon} from "components/Icon"
import styles from "./PracticalIssues.module.css"
import cx from "classnames"
import {useCallback, useState} from "react"
import {useVisible} from "hooks"
import {PracticalIssuesPopup} from "./PracticalIssuesPopup"
import {PracticalAndGradesErrorLogType} from "../AcademicErrorLogView/AcademicErrorLogView"

export type PracticalIssueItem = {
    icon: any
    label: string
    count: number
    color: string
    type: PracticalAndGradesErrorLogType
}

export function PracticalIssues({practicalIssues}: {practicalIssues: PracticalIssueItem[]}) {
    const popup = useVisible(false)
    const [selectedType, setSelectedType] = useState<PracticalAndGradesErrorLogType>(
        PracticalAndGradesErrorLogType.Practical
    )

    const onClosePopup = useCallback(() => {
        popup.close()
    }, [popup])

    return (
        <>
            <div className={styles.container}>
                {practicalIssues.map((issue, index) => (
                    <div
                        key={index}
                        className={cx(styles.card, {[styles.cardWarning]: issue.count > 0})}
                        onClick={() => {
                            setSelectedType(issue.type)
                            popup.open()
                        }}>
                        <div className={styles.iconWrap} style={{backgroundColor: issue.color + "20"}}>
                            <Icon icon={issue.icon} color={issue.color} />
                        </div>
                        <div className={styles.info}>
                            <span className={styles.count}>{issue.count}</span>
                            <span className={styles.label}>{issue.label}</span>
                        </div>
                    </div>
                ))}
            </div>

            <PracticalIssuesPopup type={selectedType} isShow={popup.isVisible} onClose={onClosePopup} />
        </>
    )
}
